import * as ExcelJS from "exceljs";
import { createExcelFileDownloadFromRawData } from "../../lib/supportFunctions";

/**
 * Builds a single-sheet .xlsx from an already-rendered table (localized headers +
 * plain-text cell values) and triggers a browser download. Kept intentionally
 * dumb: the caller (WidgetTable) owns the domain knowledge of which columns to
 * export and how each cell reads.
 */
export async function exportTableToXlsx(
  headers: string[],
  rows: string[][],
  filename: string
): Promise<void> {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Data");

  // Positional columns: addRow(array) writes by index, so duplicate header
  // labels can't collide the way keyed rows would.
  sheet.columns = headers.map(header => ({
    header,
    width: Math.max(12, Math.min(40, header.length + 6)),
  }));
  sheet.getRow(1).font = { bold: true };
  rows.forEach(row => sheet.addRow(row));

  const buffer = await workbook.xlsx.writeBuffer();
  createExcelFileDownloadFromRawData(buffer, filename);
}
